import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/Badge/Badge.styl'

type BadgeProps = {
  theme: 'success'
}

export const Badge: FC<BadgeProps> = (props) => {
  const { theme, children } = props
  const badgeClassname = cn(styles.badge, styles[theme])

  return (
    <div className={ badgeClassname }>
      <span className={ styles.text }>{ children }</span>
    </div>
  )
}
